import { PropsWithChildren } from "react";

import { cn } from "@/lib/utils";

export const BottomActionBar = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={cn(
        `fixed bottom-0 left-14 right-0 p-2 backdrop-blur-md bg-background/30 border-t border-white/20 z-[18] flex flex-row justify-start`,
        className,
      )}
    >
      {children}
    </div>
  );
};
